import Vue from 'vue'

/**
 * @typedef Image
 *
 * @property {string} directory
 * @property {string} filename
 *
 */

/**
 * @typedef Crop
 */

/**
 * Generats thumbnail image from given parameters
 *
 * @param {Image} image
 * @param {number} width
 * @param {number} height
 * @param {Crop} crop
 */
Vue.prototype.thumb = (image, width = 0, height = 0, crop = '') => {
  const directory = image.directory.replace('public/', '')
  return `${process.env.VUE_APP_PHP_THUMB_URL}?src=/${directory}/${image.filename}&w=${width}&h=${height}&zc=${crop}`
}
